import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import Textarea from '../../components/Textarea';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/plans/EditPlanUploadForm.scss';
import Input from '../../components/Input';
import DefaultImage from '../../assets/images/default.png';
import Image from '../../components/Image';
import Tags from '../../components/Tags';
import autobind from 'autobind-decorator';
import classNames from 'classnames';
import Select from '../../components/Select';
import {
  listPlanUploads,
  listPossibleTeams,
  readPlanUpload,
  rotatePlanUpload,
  updatePlanSpaceAllocation,
} from '../../redux/actions/table/plan_uploads';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { readStage } from '../../redux/actions/table/stages';
import OCRIcon from '../../assets/images/ocr-16x16.svg';
import * as _ from 'lodash';
import { listPossibleTags } from '../../redux/actions/general';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import Dropdown from '../../components/Dropdown';
import RoomChooser from '../../components/RoomChooser';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import { setNotification } from '../../redux/actions/general/notification';
import { showLightbox } from '../../redux/actions/general/lightbox';
import Tooltip from '../../components/Tooltip';
import RotateLeftIcon from '../../assets/images/rotate-left-15x15.svg';
import RotateRightIcon from '../../assets/images/rotate-right-15x15.svg';

@reduxForm({
  form: 'plans.edit_plan_upload',
  enableReinitialize: true,
})
@mapStateToProps((state) => ({
  rotation: _.get(state.table, ['plan_uploads', 'rotation'], 0),
  auth: state.auth,
  values: getFormValues('plans.edit_plan_upload')(state),
  table: state.table['plan_uploads'],
}))
@withRouter
@subscribe(Localization, 'localization')
class EditPlanUploadForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_teams: [],
      stage_tags: [],
      x: 0,
      y: 0,
      zoom: 0,
    };
  }

  componentDidMount() {
    listPossibleTeams(this.props.match.params.stage).then(({ response }) => {
      this.setState({ possible_teams: response.data });

      if (
        !_.includes(_.map(this.state.possible_teams, 'id'), this.props.team_id)
      ) {
        this.props.reset();
      }
    });

    readStage(this.props.stageId).then(({ response }) => {
      listPossibleTags('project', response.data.project_id).then(
        ({ response }) => {
          this.setState({ stage_tags: response.data });
        }
      );
    });
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  @autobind
  _handleMouseMove(e) {
    if (this.props.rotation % 360 == 0 && this.props.status === 1 && e.target) {
      const { left, top, width, height } = e.target.getBoundingClientRect();
      const x = ((e.pageX - left) / width) * 100;
      const y = ((e.pageY - top) / height) * 100;

      this.setState({ x, y });
    }
  }

  @autobind
  _handleWheel(e) {
    if (this.props.rotation % 360 == 0) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      //TODO - fix scrolling here

      this.setState({
        zoom: _.min([850, _.max([0, this.state.zoom - e.deltaY * 5])]),
      });
    }
  }

  _debouncedRotate = _.debounce((id, rotation) => {
    rotatePlanUpload(id, rotation).then(() => {
      readPlanUpload(id).then(({ response }) => {
        setTableParams('plan_uploads', {
          flyout: response.data,
        });
      });
    });
  }, 500);

  @autobind
  _rotateLeft() {
    const rotation = this.props.rotation - 90;

    setTableParams('plan_uploads', { rotation });

    // const normalizedRotation = (rotation + 360) % 360;
    // this._debouncedRotate(this.props.data.id, normalizedRotation);
  }

  @autobind
  _rotateRight() {
    const rotation = this.props.rotation + 90;

    setTableParams('plan_uploads', { rotation });

    // const normalizedRotation = (rotation + 360) % 360;
    // this._debouncedRotate(this.props.data.id, normalizedRotation);
  }

  @autobind
  _handleSpaceAllocation(values) {
    const { id } = this.props.data;

    this.props.change('space_allocation', values);

    updatePlanSpaceAllocation(id, {
      space_allocation: _.reduce(
        _.keys(values),
        (space_allocation, value) => {
          const [space_allocation_type, space_allocation_id] = _.split(
            value,
            ':'
          );

          if (!_.isArray(space_allocation[space_allocation_type])) {
            space_allocation[space_allocation_type] = [];
          }

          space_allocation[space_allocation_type].push(space_allocation_id);

          return space_allocation;
        },
        {}
      ),
    })
      .then(() => {
        this.props.match.params.stage &&
          listPlanUploads(this.props.match.params.stage);
      })
      .then(() => {
        setNotification(__('plans.properties.saved'));
      });

    hideDropdown();
  }

  render() {
    const { data, possibleSpaceAllocation } = this.props;

    const initialSpaceAllocation = _.get(
      this.props.values,
      'space_allocation',
      []
    );

    const teams = _.map(this.state.possible_teams, (team) => {
      return {
        value: team.id,
        label:
          team.company.name +
          ' [' +
          [
            team.stage_discipline.code,
            team.stage_discipline.discipline_id == null
              ? team.stage_discipline.description + '*'
              : _.get(this.props.localization, [
                  'disciplines',
                  team.stage_discipline.discipline_id,
                  'name',
                ]),
          ].join(': ') +
          ']',
      };
    });

    const getExtensionFromUrl = (url) => {
      try {
        const pathname = new URL(url).pathname;
        const parts = pathname.split('.');
        return parts.length > 1 ? parts.pop() : '';
      } catch (e) {
        return '';
      }
    };

    const ext = getExtensionFromUrl(data.preview_url);

    let lightbox_image = {
      id: this.props.data.image_id,
      stream_url: this.props.data.preview_url,
      download_url: this.props.data.download_url,
      title: `${this.props.data.title}.${ext}`,
      rotation: this.props.rotation,
    };

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.imageSection}>
          <div
            className={classNames(
              styles.image,
              this.props.rotation % 360 == 0 && styles.zoomable,
              this.props.rotation % 360 == 0 &&
                (this.state.x != 0 || this.state.y != 0) &&
                styles.zoomed
            )}
            onWheel={this._handleWheel}
          >
            <Image
              src={this.props.thumbnailUrl}
              default={DefaultImage}
              //  onMouseMove={this._handleMouseMove}
              style={{ transform: 'rotate(' + this.props.rotation + 'deg)' }}
              onClick={() => {
                showLightbox([lightbox_image], lightbox_image.id);
              }}
            />
            {this.props.previewUrl && (
              <div
                className={styles.full}
                style={{
                  backgroundImage: 'url("' + this.props.previewUrl + '")',
                  backgroundPosition: `${this.state.x}% ${this.state.y}%`,
                  backgroundSize: `${150 + this.state.zoom}%`,
                }}
              />
            )}
            {this.props.status === 1 && (
              <div className={styles.rotate}>
                <Tooltip text={__('plans.tooltip.icon.rotate-left')}>
                  <RotateLeftIcon onClick={this._rotateLeft} />
                </Tooltip>
                <Tooltip text={__('plans.tooltip.icon.rotate-right')}>
                  <RotateRightIcon onClick={this._rotateRight} />
                </Tooltip>
              </div>
            )}
          </div>

          <div className={styles.data}>
            <Field
              name='title'
              component={Input}
              maxLength={70}
              label={__('plans.table.title.title')}
              rightIcon={data.title_auto ? OCRIcon : undefined}
              rightIconTooltip={__('plans.tooltip.auto-generated-by-ocr')}
            />

            <div className={styles.flex}>
              <div className={styles.f2}>
                <Field
                  name='code'
                  component={Input}
                  label={__('plans.table.title.code')}
                  rightIcon={data.code_auto ? OCRIcon : undefined}
                  rightIconTooltip={__('plans.tooltip.auto-generated-by-ocr')}
                />
              </div>
              <div className={styles.f1}>
                {' '}
                <Field
                  name='scale'
                  component={Input}
                  label={__('Scale')}
                  rightIcon={data.scale_auto ? OCRIcon : undefined}
                  rightIconTooltip={__('plans.tooltip.auto-generated-by-ocr')}
                />
              </div>
            </div>
            <Field
              name='description'
              component={Textarea}
              localized={this.props.projectLanguages}
              label={__('Description')}
              maxLength={70}
              rows={1}
              maxRows={10}
            />
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.teamSelect}>
            <Field
              name='team_id'
              component={Select}
              searchable
              label={__('Discipline / Team')}
              options={teams}
            />
          </div>
          <Dropdown
            top={25}
            leftStyled
            wrapperClassName={styles.dropdownWrapper}
            name={'plans_flyout_area.' + data.id}
            header={
              <div className={styles.dropdownHeader}>
                {__('table.area-tab.area')}
              </div>
            }
            content={
              <div className={classNames(styles.dropdownContent, styles.space)}>
                <RoomChooser
                  multiselect={true}
                  onCancel={hideDropdown}
                  options={possibleSpaceAllocation}
                  onDone={this._handleSpaceAllocation}
                  initialValues={initialSpaceAllocation}
                />
              </div>
            }
          >
            <label className={styles.spaceAllocationLabel}>
              {__('general.label.space-allocation')}
            </label>
            <div className={styles.tagsGroup} onClick={this._handleOpen}>
              <div className={styles.tags}>
                {_.map(_.sortBy(initialSpaceAllocation), (tag, i) => (
                  <span key={i}>{tag.display_name}</span>
                ))}
              </div>
              {!this.props.center && !this.props.disabled && (
                <ArrowDownMiddleIcon />
              )}
            </div>
          </Dropdown>
          <div className={styles.f1}>
            <Field
              name='tags'
              component={Tags}
              label={__('Tags')}
              options={this.state.stage_tags}
            />
          </div>
        </div>
      </Form>
    );
  }
}

export default EditPlanUploadForm;
